import FeatureGates from '@atlaskit/feature-gate-js-client';

export type ChatRefreshV2Config = {
	isMinimodalHeightAnimationEnabled: boolean;
	isDeepResearchEnabled: boolean;
	isNewMessagesEnabled: boolean;
	isNewMessagesActionsEnabled: boolean;
	isNewAllConversationScreenEnabled: boolean;
	isNewInputPromptTypeaheadEnabled: boolean;
	isReasoningOptionsV2Enabled: boolean;
	isReasoningStickyOptionEnabled: boolean;
	isPromptLibraryEnabled: boolean;
	isChromeExtensionLinkEnabled?: boolean;
	isNewLoadingStateEnabled: boolean;
	isUpdatedAgentMenuDropdownEnabled: boolean;
	isSpinnerOverlayConversationIconEnabled: boolean;
};

export const initialState: ChatRefreshV2Config = {
	isMinimodalHeightAnimationEnabled: false,
	isDeepResearchEnabled: false,
	isNewMessagesEnabled: false,
	isNewMessagesActionsEnabled: false,
	isNewAllConversationScreenEnabled: false,
	isNewInputPromptTypeaheadEnabled: false,
	isReasoningOptionsV2Enabled: false,
	isReasoningStickyOptionEnabled: false,
	isPromptLibraryEnabled: false,
	isNewLoadingStateEnabled: false,
	isUpdatedAgentMenuDropdownEnabled: false,
	isSpinnerOverlayConversationIconEnabled: false,
};

export const getChatRefreshV2DynamicConfig = ({
	isRolloutInJiraEnabled,
}: {
	isRolloutInJiraEnabled: boolean;
}) => {
	const rovoChatRefreshV2Config =
		isRolloutInJiraEnabled ||
		FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v1_experiment',
			'isRenderRefreshEnabled',
			false,
		)
			? getChatRefreshV2ConfigFromExperimentParameters()
			: initialState;

	return rovoChatRefreshV2Config;
};

const getChatRefreshV2ConfigFromExperimentParameters = () => {
	return {
		isMinimodalHeightAnimationEnabled: false,
		isDeepResearchEnabled: FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v2_experiment',
			'isDeepResearchEnabled',
			false,
		),
		isNewMessagesEnabled: FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v2_experiment',
			'isNewMessagesEnabled',
			false,
		),
		isNewMessagesActionsEnabled: FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v2_experiment',
			'isNewMessagesActionsEnabled',
			false,
		),
		isNewAllConversationScreenEnabled: false,
		isNewInputPromptTypeaheadEnabled: false,
		isDynamicStartersAPIEnabled: false,
		isReasoningOptionsV2Enabled: false,
		isReasoningStickyOptionEnabled: false,
		isPromptLibraryEnabled: FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v2_experiment',
			'isPromptLibraryEnabled',
			false,
		),
		isNewLoadingStateEnabled: FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v2_experiment',
			'isNewLoadingStateEnabled',
			false,
		),
		isUpdatedAgentMenuDropdownEnabled: FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v2_experiment',
			'isUpdatedAgentMenuDropdownEnabled',
			false,
		),
		isSpinnerOverlayConversationIconEnabled: false,
	};
};
